import { useUnits } from '@/hooks/useUnits'
import { DATA_PAGINATION } from '@/types'
import { HydraulicType } from '@/types/hydraulic'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'
import HydraulicTableRow from './HydraulicTableRow'
import classes from './styles.module.scss'

interface HydraulicTableProps {
  rows?: DATA_PAGINATION<HydraulicType>
}

const HydraulicTable: FC<HydraulicTableProps> = ({ rows }) => {
  const { convertLabelUnit } = useUnits()

  return (
    <Stack flexGrow="1" justifyContent="space-between" height="100%">
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead
            sx={{
              backgroundColor: '#EFEFEF',
              fontWeight: 600,
              borderBottom: '1px solid #D7D7D7',
            }}
          >
            <TableRow>
              <TableCell
                sx={{
                  width: '1%',
                }}
              ></TableCell>
              <TableCell
                sx={{
                  width: '5%',
                }}
              >
                #
              </TableCell>

              <TableCell
                sx={{
                  width: '10%',
                  borderRight: '1px solid #d7d7d7',
                }}
              >
                Description
              </TableCell>

              <TableCell
                sx={{
                  width: '7%',
                }}
              >
                Pipe Capacity ({convertLabelUnit('l/m')})
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {rows?.data?.map((row) => (
              <HydraulicTableRow key={row.id} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default HydraulicTable
